// extracted by mini-css-extract-plugin
export default {"main":"Answer_main__cqbJO","marker":"Answer_marker__hk87w","checked":"Answer_checked__R8k1s","title":"Answer_title__t5wl+"};